import axios from "axios";

const API_URL = "https://hexeverestfunctions.azurewebsites.net/api/";

class AuthService {
  login(user) {
    return axios
      .post(API_URL + "Authenticate", {
        user: user.username,
        password: user.password,
      })
      .then((response) => {
        // if (response.data.token) {
        //   localStorage.setItem("user", JSON.stringify(response.data));
        // }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
    console.log("local storage cleared!");
  }

  register(user) {
    return axios.post(API_URL + "signup", {
      user: user.username,
      email: user.email,
      password: user.password,
    });
  }
}

export default new AuthService();
